import filterQueryBuilder from 'helpers/filterToQuery'
import { requests, mainApiRoot } from './index'

export const Competitors = {
  byDomain: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/overview${query}`)
  },
  history: (domainId, keywordId, filters) => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(
      mainApiRoot,
      `/domains/${domainId}/competitors/${keywordId}/history${query}`
    )
  },
  overview: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/overview${query}`)
  },
  visibility: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/visibility${query}`)
  },
  traffic: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/traffic${query}`)
  },
  position: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/position${query}`)
  },
  averagePosition: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/average-position${query}`)
  },
  serpFeature: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${domainId}/competitors/serp-feature${query}`)
  },
  serpFeatureChart: (domainId, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(
      mainApiRoot,
      `/domains/${domainId}/competitors/serp-feature-chart${query}`
    )
  },
  del: (domainId, competitorId) =>
    requests.del(mainApiRoot, `/domains/${domainId}/competitors/${competitorId}`),
  export: domainId => requests.getFile(mainApiRoot, `/domains/${domainId}/competitors/csv`)
}
